var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,[React.createElement("line",{"id":"Line_4","data-name":"Line 4","x2":"1792.5","transform":"translate(0 19.5)","fill":"none","stroke":"rgba(255,255,255,0.7)","strokeWidth":"2","strokeDasharray":"11 12","key":0}),React.createElement("path",{"id":"Polygon_1","data-name":"Polygon 1","d":"M19,0,38,32H0Z","transform":"translate(1824) rotate(90)","fill":"rgba(255,255,255,0.7)","key":1})]);
}

Arrow.defaultProps = {"id":"arrow","width":"1824","height":"38","viewBox":"0 0 1824 38"};

module.exports = Arrow;

Arrow.default = Arrow;
